import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, resource, role }) =>
    present(
      repository.saveProjectResource(resource, project, role).catch(() =>
        Promise.reject({
          role,
          project,
          resource,
        }),
      ),
    );
}

export type { Interactor };

export { createInteractor };
